module.exports = __webpack_public_path__ + "static/media/Mbti.3076fadc.png";